import PropTypes from 'prop-types'

const Steps = ({ steps, currentStep }) => {
  return (
    <div className="event-form-steps">
      {steps.map((step, index) => (
        <div className={`step ${index === currentStep ? 'active' : ''}`} key={step}>
          <div className="step__number">{index + 1}</div>
          {step}
        </div>
      ))}
    </div>
  )
}

Steps.propTypes = {
  currentStep: PropTypes.number,
  steps: PropTypes.array,
  handleStepClick: PropTypes.func.isRequired,
}

export default Steps
